import { BaseRequest } from '@/network/requests/BaseRequest'
import { process_Info } from '@/interfaces/process_Info'

export const processInfoRequest = BaseRequest.build<process_Info>('process_Info')

export const processDirections = [
	{
		value: 0,
		label: '头进尾出',
	},
	{
		value: 1,
		label: '尾进头出',
	},
	{
		value: 2,
		label: '不限',
	},
]

/**
 * 获取进料方向名称。
 * @param val 枚举值。
 */
export const getDirectionName = val => {
	var array = processDirections.filter(t => t.value == val)
	if (array) {
		return array[0].label
	}

	return ''
}

/**
 *
 * @param ids
 */
export const getProcessByIdArray = ids => {
	return processInfoRequest.queryAll({ _id: { $in: ids.map(id => ({ $oid: id })) } })
}
